import { $setTitle } from '@/utils/common/native-api';

export default {
  data() {
    return {
      // 分享的内容
      explain: {}
    }
  },
  watch: {
    title(newVal) {
      this._setTitle('watch')
    }
  },
  activated() {
    this._setTitle('activated')
  },
  methods: {
    _setTitle(method) {
      const { title } = this
      if (!title) {
        return
      }
      // 更新文档标题、原生应用标题
      this.$nextTick(() => {
        // console.log('title', this.$options._componentTag, method, title)
        document.title = title
        $setTitle({ title })
      })
    }
  }
}